<template>
  <div id="app" >
    <AppHeader />
    <main class="flex-grow-1">
      <router-view />
    </main>
    
    <FooterSection />
  </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import FooterSection from "./components/FooterSection.vue";

export default {
  name: "App",
  components: {
    AppHeader,
    FooterSection,
  },
};
</script>

<style>
@import "@/assets/css/style.css";
</style>
